import type { Cart } from "@packages/sdk";

import { ERROR_CODE_NAME_REQUIRED_TO_JOIN } from "../lib/constants/errorCodes.constants";

type GetIsCartNameRequiredErrorProps = {
  cart: Cart;
};

export const getIsCartNameRequiredError = ({
  cart,
}: GetIsCartNameRequiredErrorProps) =>
  cart?.errors?.some(
    (error) => error.code === ERROR_CODE_NAME_REQUIRED_TO_JOIN,
  );
